import React, { Component } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

const Pager = (props) => {

    function getPaginationItems(){
        const windowSize = 10;
        const halfWindow = Math.floor(windowSize / 2);
        let result = [];
        
        //first page link
        result.push(<PaginationItem key={-1} disabled={props.currentPage <= 1}><PaginationLink first onClick={(e) => props.onPageChanged(1)}>⏮</PaginationLink></PaginationItem>);
        
        //prev page link
        result.push(<PaginationItem key={0} disabled={props.currentPage <= 1}><PaginationLink previous onClick={(e) => props.onPageChanged(props.currentPage - 1)}>⏪</PaginationLink></PaginationItem>);
        
        const start = Math.max(1, props.currentPage - halfWindow);
        const end = Math.min(props.totalPages, props.currentPage + halfWindow); //offset by 2 since we always add them manually later
        const ellipsis = <PaginationItem key={-1} active={false}><PaginationLink >...</PaginationLink></PaginationItem>;

        for(let i = start; i < end + 1; i++){
            result.push(<PaginationItem key={i} active={i === props.currentPage}><PaginationLink onClick={(e) => props.onPageChanged(i)}>{i}</PaginationLink></PaginationItem>)
        }

        //add ellipsis if there is a gap between moving window and last index
        if(end < props.totalPages -2){
            result.push(ellipsis);
        }

        //always include last 2 pages
        if(props.currentPage < props.totalPages - 2){
            result.push(<PaginationItem key={props.totalPages - 1} active={props.totalPages - 1 == props.currentPage}><PaginationLink onClick={(e) => props.onPageChanged(props.totalPages - 1)}>{props.totalPages -1}</PaginationLink></PaginationItem>);
            result.push(<PaginationItem key={props.totalPages} active={props.totalPages == props.currentPage}><PaginationLink onClick={(e) => props.onPageChanged(props.totalPages)}>{props.totalPages}</PaginationLink></PaginationItem>);
        }

        // next page link
        result.push(<PaginationItem key={9999999998} disabled={props.currentPage == props.totalPages}><PaginationLink next onClick={(e) => props.onPageChanged(props.currentPage + 1)}>⏩</PaginationLink></PaginationItem>);
        
        //last page link
        result.push(<PaginationItem key={9999999999} disabled={props.currentPage == props.totalPages}><PaginationLink last onClick={(e) => props.onPageChanged(props.totalPages)}>⏭</PaginationLink></PaginationItem>);
        
        //due to global RTL
        return result.reverse();
    }

    return (
        <>
            <div style={{padding:'1rem'}}>
                <label>סה"כ שורות: {props.totalRows}</label>
            </div>

            {props.totalPages > 1 ?
                <div className="mx-auto" style={{width:'fit-content'}}>
                    {/* {props.totalPages} / {props.currentPage} */}
                    <Pagination >
                        {getPaginationItems()}
                    </Pagination>
                </div> : null }

            <div className="mx-auto text-center" style={{marginBottom:'6rem'}}>
                <label htmlFor="drpPageSize">בחר מספר שורות</label>
                <select className="col-md-1 col-sm-2 form-control mx-auto" style={{backgroundColor:'transparent'}} id="drpPageSize" value={props.pageSize} onChange={(e) => props.onPageSizeChanged(e.target.value)}>
                    {props.pageSizes.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
            </div>
        </>
    );
  };
  
  export default Pager;
  